import React from 'react';
import { Outlet } from "react-router-dom";

// import AboutHeader from '../partials/AboutHeader';

export default function About() {
  return (
    <>
      {/* <AboutHeader /> */}
      <div id="main" className='text-center'>
        <Outlet />
      </div>
    </>
  );
}